import { MdOutlineCancel } from 'react-icons/md';
import { GiConfirmed } from 'react-icons/gi';
import { FiMail } from 'react-icons/fi';


const AdminNietBevestigdeTaak = ({taak, handleBevestiging, handleVerwijdering}) => {
    
    const {taakID, activiteitDatum, activiteitNaam, taakNaam, dagdeel, vrijwilliger, vrijwilligerID, vrijwilligerOpmerking, vrijwilligerEmail, activiteitID} = taak;


    return (
        <>
            <tr>
                <td>{activiteitDatum}</td>
                <td>{activiteitNaam}</td>
                <td>{taakNaam}</td>
                <td>{dagdeel}</td>
                <td>{vrijwilliger} {vrijwilligerOpmerking && "(opmerking)"}</td>
                <td>
                    <a className="contact" href={`mailto:${vrijwilligerEmail}?subject= Brinkruiters - vrijwilligersactiviteit`} target="_blank">
                        <span><FiMail /></span>
                    </a>
                </td>
                <td>
                    <button className="bevestig" onClick={() => handleBevestiging(taakID, activiteitID)}>
                        <span><GiConfirmed /></span>
                    </button></td>
                <td>
                    <button className="verwijder" onClick={() => handleVerwijdering(taakID, activiteitID, vrijwilligerID)}>
                        <span><MdOutlineCancel /></span>
                    </button>
                </td>
            </tr>
            { vrijwilligerOpmerking &&
            <tr>
                <td></td>
                <td colSpan="7">{`${vrijwilliger}: "${vrijwilligerOpmerking}"`}</td>
            </tr>
            }
        </>
    );
}

export default AdminNietBevestigdeTaak;